import {UserInterface} from "@/models/User";

export enum ClaseEnum {
    finish = 'FINISH',
    error = 'ERROR',
    cancel = 'CANCEL'
}

export interface ClasesAlumnosInterface {
    id?: string;
    user: UserInterface;
    clase: number;
    status: ClaseEnum;
}

